<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <SearchTitle label='带教老师信息' url='/person/teach/list'></SearchTitle>
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <!--begin: Search Form -->
        <div class="m-form m-form--label-align-right">
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">管理单元：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.secretarysec" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in managesecOptions" :key="item.DictItemID" :label="item.DictItemName" :value="item.DictItemID">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <SearchNormalText v-model='condition.truename' label='姓名'></SearchNormalText>
          <SearchNormalText v-model='condition.cardno' label='工号'></SearchNormalText>
          <ZPGLSearchDictItemSelect v-model='condition.edu' label='学历' :dictid='this.$utils.DictEnum.edu'></ZPGLSearchDictItemSelect>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">带教资质：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.qualifications" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;">
          <SearchButton :url='searchUrl' ref="btnSearch"></SearchButton>
          <ImportButton url="/person/teach/import" buttonname="导入"></ImportButton>
          <AddButton url="/person/teach/add" buttonname="新增"></AddButton>
          <ExportButton :url='exportUrl' buttonname="导出"></ExportButton>
        </div>
        <!--end: Search Form -->
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <!--begin: Datatable -->
          <el-table v-loading="loading" :data="tableData" stripe style="width: 100%" size="medium">
            <el-table-column>
              <template slot="header">
                姓名<br>工号
              </template>
              <template slot-scope="scope">
                {{scope.row.TrueName}}<br>{{scope.row.CardNo}}
              </template>
            </el-table-column>
            <el-table-column prop="SectionName" label="管理单元">
            </el-table-column>
            <el-table-column>
                <template slot="header">
                  职称<br>职务
                </template>
                <template slot-scope="scope">
                  {{scope.row.TitleName}}<br>{{scope.row.DutyName}}
                </template>
            </el-table-column>
            <el-table-column prop="EduName" label="学历">
            </el-table-column>
            <el-table-column label="带教资格">
              <template slot-scope="scope">
                <span v-bind:style="scope.row.QualificationsName == '有'?'color:green;':'color:red;'">{{scope.row.QualificationsName}}</span>
                <el-button @click="ChangeValid(scope.row)" type="text" size="medium">[变更]</el-button>
              </template>
            </el-table-column>
            <el-table-column>
              <template slot="header">
                现带教人数<br>总带教人数
              </template>
              <template slot-scope="scope">
                {{scope.row.CurrentCount}}<br>{{scope.row.TotalCount}}
              </template>
            </el-table-column>
            <el-table-column prop="MaxScore" label="最高分">
            </el-table-column>
            <el-table-column prop="MinScore" label="最低分">
            </el-table-column>
            <el-table-column>
              <template slot="header">
                平均分<br>评分次数
              </template>
              <template slot-scope="scope">
                {{scope.row.AvgScore|formatNum}}<br>{{scope.row.ScoreCount}}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="160">
              <template slot-scope="scope">
                <el-button @click="Info(scope.row)" type="text" size="medium">评分详细</el-button>
                <el-button @click="Edit(scope.row)" type="text" size="medium">修改</el-button>
                <el-button @click="Delete(scope.row)" type="text" size="medium" style="color: red;">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!--end: Datatable -->
          <div style="margin-top: 10px;text-align: center;">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="condition.currentPage"
              :page-sizes="[2, 10, 20, 30, 40]" :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
              :total="condition.recordCount">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TeachList',
    data() {
      return {
        condition: {
          username: '',
          rolelevel: '',
          secid: '',
          truename: '',
          cardno: '',
          edu: '',
          qualifications: '',
          token: '',
          responseType: 'blob',
          pageSize: 10,
          currentPage: 1,
          recordCount: 0,
          firstSearch: true,
          secretarysec: ''
        },
        secOptions: [],
        managesecOptions: [],
        options: [{
            value: '1',
            label: '有'
          },
          {
            value: '0',
            label: '无'
          }
        ],
        tableData: null,
        searchUrl: this.$utils.Url.zpgl + '/api/APITeacher/List',
        exportUrl: this.$utils.Url.zpgl + '/api/APITeacher/ListOut',
        loading: true
      }
    },
    filters: {
      formatNum(val) {
        return val.toFixed(2)
      }
    },
    methods: {
      // 调整每页显示数
      handleCurrentChange: function(val) {
        this.condition.firstSearch = false
        this.condition.currentPage = val
        this.$refs.btnSearch.Search()
      },
      // 分页操作
      handleSizeChange: function(val) {
        this.condition.firstSearch = false
        this.condition.pageSize = val
        this.condition.currentPage = 1
        this.$refs.btnSearch.Search()
      },
      Info: function(row) {
        this.$router.push({
          name: 'TeachScoreList',
          params: {
            tecid: row.TecID,
            tecname: row.TrueName,
            secname: row.SectionName
          }
        })
      },
      Edit: function(row) {
        this.$router.push({
          name: 'TeachEdit',
          params: {
            id: row.TecID
          }
        })
      },
      Delete: function(row) {
        var args = {
          id: row.TecID,
          token: this.condition.token
        }
        this.$utils.Delete(this.$utils.Url.zpgl + '/api/APITeacher/Delete', args, row.TrueName, this.$refs.btnSearch.Search)
      },
      ChangeValid: function(row) {
        var tecname = row.TrueName
        var qualifications = 1
        if (row.Qualifications === 1) {
          qualifications = 0
        }
        var args = {
          id: row.TecID,
          qualifications: qualifications,
          token: this.condition.token
        }
        this.$utils.Change(this.$utils.Url.zpgl + '/api/APITeacher/UpdateValid', args, '确定变更' + tecname + '的带教资质?', this.$refs
          .btnSearch.Search)
      },
      LoadManageSec:function(){
        var args = {
          token: this.condition.token,
          username: this.condition.username,
          rolelevel: this.condition.rolelevel
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/ManageSecionList', args, function(data) {
          that.managesecOptions = data.Data
        }, null, null, null)
      }
    },
    mounted: function() {
      this.condition.token = sessionStorage.getItem('token')
      this.condition.username = sessionStorage.getItem('username')
      this.condition.rolelevel = sessionStorage.getItem('rolelevel')
      this.condition.secid = sessionStorage.getItem('secid')
      this.LoadManageSec()
      this.$refs.btnSearch.Search()
    }
  }
</script>

<style scoped="scoped">
  body {
    margin: 0;
  }
  /deep/.el-table .cell {
      line-height: 20px;
  }
</style>
